<template>
    <rkm-table
        :fields="fields"
        :items="items || []"
        sort-by="nome"
    >

        <template v-slot:cell(tipo)="row">
            <span v-if="row.item.tipo == enums.tipoFator.CONSTANTE">
                Constante
            </span>

            <span v-else>
                Variável
            </span>
        </template>

        <template v-slot:cell(valor)="row">
            <span v-if="row.item.valor > tipoValor">
                {{ row.item.valor }}
            </span>

            <span v-else>
                -
            </span>
        </template>

        <template v-slot:cell(exponenciacao)="row">
            <span v-if="row.item.exponenciacao">
                Sim
            </span>

            <span v-if="!row.item.exponenciacao">
                Não
            </span>
        </template>

        <template v-slot:cell(exponenciacaoTipo)="row">
            <span v-if="row.item.exponenciacaoTipo == enums.tipoFator.CONSTANTE">
                Constante
            </span>

            <span v-else-if="row.item.exponenciacaoTipo == enums.tipoFator.VARIAVEL">
                Variável
            </span>

            <span v-else>
                -
            </span>
        </template>

        <template v-slot:cell(exponenciacaoValor)="row">
            <span v-if="row.item.exponenciacaoValor > tipoValor">
                {{ row.item.exponenciacaoValor }}
            </span>

            <span v-else>
                -
            </span>
        </template>

        <template v-slot:cell(actions)="{ index, item }">
            <rkm-button
                @click.stop="$emit('handleAlter', index, item)"
                color="primary"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>

// Enums.
import tipoFator from '@/enums/exame-laboratorial/tipoFator'

export default {
    data: () => ({
        fields: [
            {
                name: 'fator',
                key: 'fator',
                label: 'Fator',
                sortable: true
            },
            {
                name: 'operacaoDescricao',
                key: 'operacaoDescricao',
                label: 'Operação',
                sortable: true
            },
            {
                name: 'tipo',
                key: 'tipo',
                label: 'Tipo',
                sortable: true
            },
            {
                name: 'valor',
                key: 'valor',
                label: 'Valor',
                sortable: true
            },
            {
                name: 'exponenciacao',
                key: 'exponenciacao',
                label: 'Exponenciação',
                sortable: true
            },
            {
                name: 'exponenciacaoTipo',
                key: 'exponenciacaoTipo',
                label: 'Expon. Tipo',
                sortable: true
            },
            {
                name: 'exponenciacaoValor',
                key: 'exponenciacaoValor',
                label: 'Expon. Valor',
                sortable: true
            },            {
                name: 'ordem',
                key: 'ordem',
                label: 'Ordem',
                sortable: true
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        tipoValor: '0,000000',
        enums: {
            tipoFator,
        },
    }),
    methods: {
        handleDestroy(item) {

            const objId =this.items.findIndex((obj => obj.id == item.id));

            const destroy = async () => {

                this.items.splice(objId, 1)
            }

            this.showDeleteConfirmation('Deseja realmente excluir o fator?', destroy, this.handleError)
        },
    },
    props: {
        items: { type: Array, required: true },
    },
}
</script>